import { useEffect } from "react";

const ORIGIN = "https://pileglidepro.com";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, val] = selector.match(/\[([^=]+)=["']([^"']+)["']\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO: title, description, canonical, OG, Twitter card.
 * Called from each top-level page component.
 */
export default function useSEO({ title, description, path, image = "/images/logo.png" }) {
  useEffect(() => {
    const fullTitle = title;
    const canonical = `${ORIGIN}${path}`;
    const absImage = image.startsWith("http") ? image : `${ORIGIN}${image}`;

    document.title = fullTitle;

    setMeta('meta[name="description"]', "content", description);

    // Open Graph
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:image"]', "content", absImage);
    setMeta('meta[property="og:site_name"]', "content", "Secure Stay Marine");

    // Twitter
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", absImage);

    // Canonical URL
    setLink("canonical", canonical);
  }, [title, description, path, image]);
}
